import { track } from "../track";

export const trackCreatePageView = (params: { view_count: number }) =>
  track({ event: "create_page_view", ...params });
